import UniversalHeader from "./UniversalHeader";
const AdminHeader = () => { 
  return (
    <>
     <UniversalHeader />
    </>
  );
};

export default AdminHeader;
